import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { AlertProvider } from '@ascend/alert';
import { registerSW } from 'virtual:pwa-register';
import { AppLockProvider } from './components/AppLock';
import { AppGate } from './AppGate';
import '@ascend/alert/styles.css';
import '@ascend/about-modal/styles.css';
import 'calc-sidebar/styles.css';
import 'calc-controls/styles.css';
import './styles/tokens.css';
import './styles/reset.css';
import './styles/global.css';
import './styles/applock.css';
import './styles/feedback.css';

registerSW({ onNeedRefresh() {}, onOfflineReady() {} });

const container = document.getElementById('root');
if (!container) throw new Error('Root element #root not found');

createRoot(container).render(
  <StrictMode>
    <AlertProvider>
      <AppLockProvider>
        <AppGate />
      </AppLockProvider>
    </AlertProvider>
  </StrictMode>,
);
